import React from 'react';
import { EditIcon, CalendarIcon, DollarSignIcon, Trash2Icon, UserIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export interface Payout {
  id: string;
  amount: number;
  date: string;
  customerId?: string;
  customerName?: string;
  notes?: string;
}
interface PayoutCardProps {
  payout: Payout;
  index: number;
  onEdit: (payout: Payout) => void;
  onDelete: (payout: Payout) => void;
  readOnly?: boolean;
}
export function PayoutCard({
  payout,
  index,
  onEdit,
  onDelete,
  readOnly = false
}: PayoutCardProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    delay: index * 0.05
  }} className="bg-white rounded-xl p-5 shadow-sm border border-stone-100 hover:shadow-md transition-shadow duration-200" data-id="element-444" data-mp="1okp8jback51j">
      <div className="flex items-start justify-between mb-3" data-id="element-445" data-mp="38zish4jikpce">
        <div className="flex-1" data-id="element-446" data-mp="3qrzg3tp2qvma">
          <div className="flex items-center gap-2 text-sm text-stone-500 mb-2" data-id="element-447" data-mp="3qrpvymqpnioi">
            <CalendarIcon className="w-4 h-4 text-teal-600" data-id="element-448" data-mp="3vrlrdxlce1sg" />
            <span data-id="element-449" data-mp="3vozmk5pu60dx">{new Date(payout.date).toLocaleDateString('da-DK')}</span>
          </div>
          {payout.customerName && <div className="flex items-center gap-2 text-sm text-stone-600 mb-2" data-id="element-450" data-mp="3lsmrb3en7eh2">
              <UserIcon className="w-4 h-4 text-blue-600" data-id="element-451" data-mp="3luppwbtv2fxe" />
              <span className="font-medium" data-id="element-452" data-mp="dee9mqdns83o">{payout.customerName}</span>
            </div>}
        </div>
        {!readOnly && <div className="flex items-center gap-1" data-id="element-453" data-mp="ie0nn21b9sdj">
            <button onClick={() => onEdit(payout)} className="p-1.5 text-stone-400 hover:text-teal-600 hover:bg-teal-50 rounded-lg transition-all" aria-label="Rediger udbetaling" data-id="element-454" data-mp="3mi6v20mntt4">
              <EditIcon className="w-4 h-4" data-id="element-455" data-mp="wa4aga9uuyfz" />
            </button>
            <button onClick={() => onDelete(payout)} className="p-1.5 text-stone-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all" aria-label="Slet udbetaling" data-id="element-456" data-mp="113fk0j61xtbl">
              <Trash2Icon className="w-4 h-4" data-id="element-457" data-mp="15xqdhg270dq0" />
            </button>
          </div>}
      </div>

      {payout.notes && <div className="text-sm text-stone-600 mb-4 line-clamp-2" dangerouslySetInnerHTML={{
      __html: payout.notes
    }} data-id="element-458" data-mp="wzedwojcm5lf" />}

      <div className="pt-4 border-t border-stone-100" data-id="element-459" data-mp="n91vp2z0aoig">
        <div className="flex items-center justify-between" data-id="element-460" data-mp="n8a2fysvt2vc">
          <div className="flex items-center gap-2" data-id="element-461" data-mp="i9gwqsju6g5q">
            <DollarSignIcon className="w-4 h-4 text-red-600" data-id="element-462" data-mp="ia8g9505snfn" />
            <span className="text-sm text-stone-500" data-id="element-463" data-mp="e96ikslw4jfs">Beløb</span>
          </div>
          <span className="text-xl font-bold text-red-700" data-id="element-464" data-mp="99tu63fdf4b3">
            -{payout.amount.toLocaleString('da-DK')} kr
          </span>
        </div>
      </div>
    </motion.article>;
}